export default __webpack_public_path__ + "static/media/img (2).55862a05.jpg";